import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export function AppShell({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const { pathname } = useLocation();
  const { isAuthenticated, user, login, logout, azureAuthConfigured } = useAuth();
  const onInvitePage = pathname.startsWith('/merchants/invite');
  const merchantsNavActive =
    pathname.startsWith('/merchants') && !onInvitePage;

  return (
    <div className="bo-root">
      <header className="bo-topbar">
        <div className="bo-brand">Triplicity Backoffice</div>
        <nav className="bo-nav" aria-label="Main">
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
          >
            Home
          </NavLink>
          {isAuthenticated ? (
            <>
              <NavLink
                to="/admin/dashboard"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Admin dashboard
              </NavLink>
              <NavLink
                to="/admin/discount-codes"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Discount codes
              </NavLink>
              <NavLink
                to="/admin/feature-flags"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Feature flags
              </NavLink>
              <NavLink
                to="/admin/invitations"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Invitations
              </NavLink>
              <NavLink
                to="/admin/audit-logs"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Audit logs
              </NavLink>
              <NavLink
                to="/admin/security"
                end
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Security
              </NavLink>
              <NavLink
                to="/admin/security/api-activity"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                API activity
              </NavLink>
              <NavLink
                to="/admin/security/download-alerts"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Download alerts
              </NavLink>
              <NavLink
                to="/admin/shopify-compliance-requests"
                className={({ isActive }) => (isActive ? 'bo-nav-active' : undefined)}
              >
                Shopify compliance
              </NavLink>
              <NavLink
                to="/merchants"
                className={() => (merchantsNavActive ? 'bo-nav-active' : undefined)}
              >
                Merchants
              </NavLink>
              <NavLink
                to="/merchants/invite"
                className={() => (onInvitePage ? 'bo-nav-active' : undefined)}
              >
                Invite merchant
              </NavLink>
            </>
          ) : null}
        </nav>
        <div className="bo-topbar-user" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {isAuthenticated && user ? (
            <>
              <span style={{ fontSize: '0.85rem', opacity: 0.9 }} title={user.id}>
                {user.displayName}
              </span>
              <button type="button" className="bo-btn bo-btn-secondary" onClick={logout}>
                Sign out
              </button>
            </>
          ) : (
            <button type="button" className="bo-btn bo-btn-primary" onClick={login}>
              {azureAuthConfigured ? 'Sign in' : 'Sign in (stub)'}
            </button>
          )}
        </div>
      </header>
      <main className="bo-main">{children}</main>
    </div>
  );
}
